export default "__VITE_ASSET__BKZRM6nM__"